import { Component, OnInit, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, FormArray, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../../../data.service';
import { CommonService } from '../../../services/common.service';
import { AppData } from '../../../constants/app-data';
import { GlobalConstant } from '../../../constants/global-constant';
import { UrlConstant } from '../../../constants/url-constant';
import { NotificationService } from "../../../services/notification.service";



@Component({
  selector: 'app-individual-create',
  templateUrl: './individual-create.component.html',
  styleUrls: ['./individual-create.component.css']
})
export class IndividualCreateComponent implements OnInit {

  formSubmitAttempt: boolean;
  formDataInvalid: boolean;
  submitBtnName = GlobalConstant.CREATE;
  submitWithCreateLinkBtn: boolean = true;
  submitWithCreateLinkBtnName = "Create And Generate Link for Test";
  resetData: any;
  message: any;
  isPageForUpdate: boolean = false;
  //userId: any;
  //userType: any
  
   //today's date
   todayDateFilter:Date = new Date();
	//any date
  //someDateFilter: Date = new Date(anydate);
   customDateFilter = (d: Date | null): boolean => {
    const day = (d || new Date()).getDay();
    // Prevent Saturday and Sunday from being selected.
     return day !== 0 && day !== 6;
    }
  individual = new FormGroup({
    id: new FormControl(''),
    loginUserId: new FormControl('', [ Validators.minLength(8), Validators.maxLength(50) ]),
    firstName: new FormControl('', [Validators.maxLength(50)]),
    middleName: new FormControl('', [ Validators.maxLength(50) ]),
    lastName: new FormControl('', [ Validators.maxLength(50) ]),
    individualTypeStr: new FormControl(''),
    expiryDate: new FormControl(''),
    status: new FormControl(''),
    createdForCompany: new FormControl(''),
    addressList: new FormArray([]),
    contactList: new FormArray([]),
    roleList: new FormControl(''),
    privList: new FormControl('')
  });
  
  getSingleAddress(){
  	return this.formBuilder.group({
  	  id: new FormControl(''),
      addressTypeStr: new FormControl(''),
      addressLine1: new FormControl('', [ Validators.minLength(5), Validators.maxLength(50) ]),
      addressLine2: new FormControl('', [ Validators.minLength(5), Validators.maxLength(50) ]),
      city: new FormControl('', [ Validators.minLength(1), Validators.maxLength(30) ]),
      state: new FormControl('', [ Validators.minLength(1), Validators.maxLength(20) ]),
      country: new FormControl('', [ Validators.minLength(1), Validators.maxLength(20) ]),
      pinCode: new FormControl('', [ Validators.minLength(5), Validators.maxLength(50) ])
    });
  }
  
  getSingleContact(){
  	return this.formBuilder.group({
      id: new FormControl(''),
      contactType: new FormControl(''),
      contactDetail: new FormControl('')
    });
  }
  
  
  constructor(private router: Router, private routeParams: ActivatedRoute, private formBuilder: FormBuilder,
  			private cdref: ChangeDetectorRef,
  			public appData: AppData, private dataService: DataService, private commonService: CommonService,
  			public notificationService: NotificationService) { }
	

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }
  
  ngOnInit(): void {
  	console.log("userId:"+this.appData.userId);
  	
  	
	let indivId = this.routeParams.snapshot.params['id'];
	console.log("this.appData.selectedComapnyId :" + this.appData.selectedComapnyId );
	
  	this.resetData = this.prepareBlankData();
  	
  	if(this.appData.addressTypes === undefined)
		this.commonService.prepareAddressTypes();
	if(this.appData.individualTypes === undefined)
		this.commonService.prepareIndividualTypes();
	if(this.appData.contactTypes === undefined)
		this.commonService.prepareContactTypes();	
	
	if(indivId == undefined || indivId == ""){
		this.appData.user.subscribe(userData=> { 
  		//this.userId = (userData !== null)? userData.id:""; 
  		//this.userType = (userData !== null)? userData.individualType:"";
  		if(userData){
	  		console.log("indivType:" + userData.individualType + "  loggedInuserid:"+userData.id + "  createdForCompany:"+userData.createdForCompany);
	  	
	  		if(this.appData.userId !== "Admin")
	  			this.resetData.createdForCompany = userData.createdForCompany;
  		}
  		//indivId = this.userId;
  	});
  	
  	
	}
	
    if( indivId !== undefined){
    	this.submitBtnName = GlobalConstant.UPDATE;
    	this.submitWithCreateLinkBtn = false;
		this.getAndPopulateData({ 'id' : indivId });
	} else{ 
		//let arr = this.individual.controls.addressList as FormArray;
		//let arraylen = arr.length;
		this.addressArray.push( this.getSingleAddress());
		this.contactArray.push( this.getSingleContact());
		this.individual.patchValue(this.resetData);
	}

  }
  
	  //Below method is used in html files as well. otherwise html gives error
	  get addressArray(){
	  	return this.individual.controls.addressList as FormArray;
	  }
	  //Below method is used in html files as well. otherwise html gives error
	  get contactArray(){
	  	return this.individual.controls.contactList as FormArray;
	  }

	deleteContact(index){
		if(this.contactArray.length > 1){
			this.contactArray.removeAt(index);
			console.log("delete-"+this.contactArray.length);
		} else {
			console.log("Length smaller");
		}
		return false;
	}
	addContact(){
		this.contactArray.push( this.getSingleContact());
		return false;
	}
	deleteAddress(index){
		if(this.addressArray.length > 1){
			this.addressArray.removeAt(index);
			console.log("delete-"+this.addressArray.length);
		} else {
			console.log("Length smaller");
		}
		return false;
	}
	addAddress(){
		this.addressArray.push( this.getSingleAddress());
		return false;
	}
	
  getAndPopulateData(body){
  	this.dataService.sendPostRequestWithBody(UrlConstant.apiGetIndividual, body).subscribe((res: any)=>{
      console.log(res);
      if(res.data.length > 0){
      	res.data[0].addressList.forEach(d => { 
      		d.addressTypeStr = d.addressType;
			this.addressArray.push( this.getSingleAddress()) ;
			
      	});
      	res.data[0].contactList.forEach(d => {
      		d.contactTyepStr = d.contactType;
      		this.contactArray.push( this.getSingleContact());
      	});
      	if(res.data[0].expiryDate!==null && res.data[0].expiryDate!=undefined)
			res.data[0].expiryDate = new Date(res.data[0].expiryDate);
      	this.updateUIData(res.data[0]);
      	if(res.data[0].createdForCompany !== null && res.data[0].createdForCompany !== 1) // Not a Trial Enterprise
      		this.updateAssignedRoles({'userId':res.data[0].loginUserId});
      	
      	this.updateAssignedPrivileges({'userId':res.data[0].loginUserId});
      	
      	this.isPageForUpdate = true;
      }
    });
  }
  
  updateUIData(dataObject){
  	dataObject.individualTypeStr = dataObject.individualType;
  	this.resetData = dataObject;
  	this.individual.patchValue(this.resetData);
  	if(this.resetData.id !== undefined && this.resetData.id !== '') 
  		this.submitBtnName = GlobalConstant.UPDATE;
  		this.submitWithCreateLinkBtn = false;
  }
  
    updateAssignedRoles(body){
		this.dataService.sendPostRequestWithBody(UrlConstant.apiGetLoggedInUserAllRoles, body).toPromise().then((data: any)=>{
		if("SUCCESS" === data.status){
				console.log(this.resetData);
				console.log(data);
				data.data.forEach( role => { this.resetData.roleList.push(role.id); } );
				this.individual.patchValue(this.resetData);
				//this.resetData.owner.roleList = r;
			}
		});
	  }

    updateAssignedPrivileges(body){
		this.dataService.sendPostRequestWithBody(UrlConstant.apiGetLoggedInUserAllPrivileges, body).toPromise().then((data: any)=>{
		if("SUCCESS" === data.status){
				console.log(this.resetData);
				console.log(data);
				data.data.forEach( priv => { this.resetData.privList.push(priv.id); } );
				this.individual.patchValue(this.resetData);
			}
		});
	  }


  	onSubmit(btnClickName) {
		  // TODO: Use EventEmitter with form value
	    var reqBody = this.individual.value;
	    //console.log('----'+reqBody);
	    this.formSubmitAttempt = true;
	    if (this.individual.valid) {
	      try {
	      	let url = UrlConstant.apiCreateIndividual;
		      //console.log(reqBody);
		      if(reqBody.id !== '' && GlobalConstant.UPDATE == btnClickName){
		      	url = UrlConstant.apiUpdateIndividual;
		      } else if(GlobalConstant.CREATE != btnClickName){
				  url = UrlConstant.apiCreateIndividualWithEvalLinkGeneration;
			  }
		 	  this.dataService.sendPostRequestWithBody(url ,reqBody).subscribe((data: any)=>{
		 		console.log(data);
			      if("SUCCESS" === data.status){
			      	console.log("success code");
			      	this.updateUIData(data.data);
			      	if(reqBody.id !== ''){
			      		this.notificationService.success("Individual Updated Successfully. " );
			      	} else {
				      	this.message = "Please login with Password: " + data.message;
				      	this.notificationService.success("Individual User Created Successfully. " + this.message);
			      	}
		      		//this.router.navigate(['/dashboard', { 'userId': '' }]);
			      } else {
			        console.log("There is some issue while updating data");
			        this.notificationService.error(data.message);
		      		//this.router.navigate(['/dashboard', { 'userId': username }]);
			      }
			      this.formSubmitAttempt = false;
			  });
		    
	      } catch (err) {
	        console.log(err);
	      }
	    } else {
	      this.formSubmitAttempt = false;
	      this.formDataInvalid = true;
	    }
		  
	  
	}


	prepareBlankData(){
		let compId = this.appData.selectedComapnyId !== undefined ? this.appData.selectedComapnyId : '';
		let data = {
		    id: '',
		    loginUserId: '',
		    firstName: '',
		    middleName: '',
		    lastName: '',
		    individualTypeStr: '',
		    expiryDate: '',
		    status: '',
		    createdForCompany: compId,
		    addressList: [],
		    contactList: [],
		    roleList: [],
		    privList: []
	  };
	  
	  for(let i=0; i<this.addressArray.length; i++){
	  	data.addressList.push({
			addressTypeStr: '',
			addressLine1: '',
			addressLine2: '',
			city: '',
			state: '',
			country: 'India',
			pinCode: ''
		});
	  }
	  for(let i=0; i<this.contactArray.length; i++){
	  	data.contactList.push({
			contactType: '',
			contactDetail: ''
		});
	  }
	  
	  return data;
	}
	
    clearIndividualSystem() {
    	this.resetData = this.prepareBlankData();
		console.log("Clear::" + this.resetData	);
		
	  	this.individual.patchValue(this.resetData);
	  	return false;
	}
	
	
}
